import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { MyCompanyPanelGzDataProvider } from '../dataProvider/MyCompanyPanelGzDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class MyCompanyPanelDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MyCompanyPanelGzDataProvider);
  }
}
